import React from 'react';
import Header from './templates/Header'
import Inicio from './templates/Inicio'
import About from './templates/About'
import Portfolio from './templates/Portfolio'
import Contact from './templates/Contact'
import '../css/App.css';

//AOS
import Aos from 'aos';
import 'aos/dist/aos.css';

const App = () => {
  React.useEffect(() => {
    Aos.init({duration: 1100});
  }, [])

  const handleOffHeader = () => {
    let menu = document.getElementById('menu')
    if(menu.classList.contains('active')) {
      menu.classList.toggle('active')
      document.getElementById('hamburguer').classList.toggle('active')
    }
  }
    
  return(
    <div className="App">
      <Header />

      <div className="wrap" onClick={handleOffHeader}>
          <Inicio 
            title="Mauro Araujo"
            subtitle="Fullstack Web Developer"
          />
          <About 
            title="SOBRE MÍ"
            content="Me considero una persona curiosa, inquieta, y un tanto ambiciosa. Me gusta aprender nuevas tecnologías e investigar, usar todo el conocimiento adquirido para resolver problemas y exprimir al máximo mi creatividad. Actualmente me encuentro trabajando como Desarrollador Web Freelance con el objetivo de adquirir experiencia y obtener más oportunidades laborales."
          />
          <Portfolio />
          <Contact />
      </div>

    </div>
  )
  
}



export default App;
